module.exports = __webpack_public_path__ + "static/media/project-finder-header-image.4f5d8f6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project-finder-header-image.png
// module id = 1433
// module chunks = 0 1